import React from 'react';
import {Route, Switch} from 'react-router-dom';
import AuthenticatedRoute from './AuthenticatedRoute';
import App from './App';

// pages
import SignIn from './views/pages/signin';
import Register from './views/pages/register';
import ForgetPass from './views/pages/forget';
import Page404 from './views/pages/404';
import PageInvoice from './views/pages/invoice';
import PrivacyPage from './views/pages/privacy-page';
import CoookiesPage from './views/pages/cookies-page';
import CustomerAwarenessPolicy from './views/pages/customer-policy';
import Faq from './views/pages/faqs';
// import FAQAccordion from './views/pages/faqs';
// import Faq from './views/pages/faqs';

export default (
    <Switch>
        {/*<Route component={Mail} path='/mail'/>*/}
        <Route component={SignIn} path='/signin'/>
        <Route component={Register} path='/pages/register'/>
        <Route component={ForgetPass} path='/pages/forget'/>
        <Route component={Page404} path='/pages/404'/>
        <Route component={PageInvoice} path='/pages/invoice'/>
        <Route component={PrivacyPage} path='/pages/privacy-page'/>
        <Route component={CoookiesPage} path='/pages/cookies-page'/>
        <Route component={CustomerAwarenessPolicy} path='/pages/customer-policy'/>
        <Route component={Faq} path='/pages/faqs'/>

        <AuthenticatedRoute component={App} path='/' />
    </Switch>
);



// WEBPACK FOOTER //
// ./src/routes.js